import React from "react";
import CurrencyFormat from "react-currency-format";
import { Icon, TooltipHost, Text } from "@fluentui/react";
import {calculateBundleItemCost, IProductBundleItem} from "../../models/ProductBundles";

interface IProductBundleItemCostDisplayProps {
    item?: IProductBundleItem;
}

export const ProductBundleItemCostDisplay: React.FC<IProductBundleItemCostDisplayProps> = (props) => {
    function formatCurrency(amount?: number) {
        if (!amount) return null;
        return <CurrencyFormat
            value={amount}
            displayType="text"
            thousandSeparator=","
            prefix="$"
            decimalScale={2}
            fixedDecimalScale={true}
        />;
    }

    const calculateSelectedCost = () : {cost?: number, message?: string, icon?: React.ReactElement } | undefined => {
        if (props.item?.details?.overrideCost) return {
            cost: props.item.details.overrideCost,
            message: "Override"
        }
        if (props.item?.details?.discountedCost) return {
            cost: props.item.details.discountedCost,
            icon: <Icon iconName='Coupon' />,
            message: "Discounted (Quantity Price Break)"
        }
        if (props.item?.vendors) {
            return {
                cost: calculateBundleItemCost(props.item.vendors, props.item?.details?.source, props.item?.details?.discountedCost, props.item?.details?.overrideCost)
            }
        }
        return undefined;
    }

    const renderRange = () => {
        if (props.item?.vendors) {
            const costs = props.item?.vendors.map(v => v.cost).filter(c => c != null) as number[];
            if(costs.length > 0) {
                const lowestCost = Math.min(...costs);
                const highestCost = Math.max(...costs);
                if (lowestCost && highestCost) {
                    return <>
                        {formatCurrency(lowestCost)} - {formatCurrency(highestCost)}
                    </>;
                }
            }
        }
        return undefined;
    }

    const selectedCost = calculateSelectedCost();
    const range = renderRange();

    const inStock = props.item?.vendors?.some(v => v.inStock || v.onHand && v.onHand > 0);

    if ((selectedCost?.cost === undefined || selectedCost.cost === 0) && range === undefined) return (
        <span className={inStock ? 'in-stock-dense' : 'no-stock-dense'}>
            N/A
        </span>
    );

    return <div className={inStock ? 'in-stock-dense' : 'no-stock-dense'}>
        {/* {inStock ? <span>In Stock{totalInStock > 0 ? `: ${totalInStock}` : ''} </span> : <span>No Stock</span>} */}
        {selectedCost?.cost ? <>
            <Text variant='mediumPlus' style={{fontWeight: 'bold'}} >
                {formatCurrency(selectedCost.cost)}
            </Text>
            {selectedCost.icon && <span style={{marginLeft: '5px'}}>
                <TooltipHost content={selectedCost.message}>
                    {selectedCost.icon}
                </TooltipHost>
            </span>}
        </> : null}
        {range && <span style={{fontStyle: 'italic'}}>
            <br />
            {range}
        </span>}
    </div>
};

export default ProductBundleItemCostDisplay